module.exports = __webpack_public_path__ + "static/1-ea10c06b78555aa6ce62b0cf36c8e289.png";